import styles from './AddSocialMediaForm.module.scss';
import { Button, Form, Input } from 'antd';
import { ISocialMediaData } from 'src/core/repo/profile/type';
import { MdChevronLeft } from 'react-icons/md';
import { useUpdateProfileSocialMedia } from 'src/core/repo/profile/useCase';
import { useState } from 'react';
import { useQueryClient } from 'react-query';

interface Props {
  setIsSocialMediaModalOpen: (status: boolean) => void;
  socialMediaData: ISocialMediaData[];
  isLoading: boolean;
  ProfileID?: number | null;
}

const AddSocialMediaModal = ({
  setIsSocialMediaModalOpen,
  socialMediaData,
  isLoading,
  ProfileID,
}: Props) => {
  const [selectedSocial, setSelectedSocial] = useState<ISocialMediaData | null>(
    null,
  );
  const [form] = Form.useForm();
  const profileSocialMediaMutation = useUpdateProfileSocialMedia();
  const queryClient = useQueryClient();

  const handleSubmit = (values: { Label: string; URL: string }) => {
    profileSocialMediaMutation.mutate(
      {
        profile_id: ProfileID || 1,
        profile_socialLink_id: 0,
        socialMedia_id: selectedSocial?.SocialMediaID || 0,
        socialLink_URL: values.URL,
        socialLink_title: values.Label,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(['profile-info']);
          setIsSocialMediaModalOpen(false);
        },
      },
    );
  };

  return (
    <div className={styles.modal}>
      {selectedSocial ? (
        <div className={styles.createModalFrom}>
          <Button
            onClick={() => {
              setIsSocialMediaModalOpen(false);
              setSelectedSocial(null);
            }}
            className={styles.backButton}>
            <MdChevronLeft size="16px" />
            <span>Back</span>
          </Button>
          {/* createModalFrom */}
          <div>
            <h2>{selectedSocial?.Title} URL</h2>
            <p>Choose you social platform then enter your URL</p>

            <Form
              onFinish={handleSubmit}
              form={form}
              layout="vertical"
              className={styles.formModal}>
              <Form.Item
                label="Label"
                name="Label"
                rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item label="URL" name="URL" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item>
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  loading={profileSocialMediaMutation.isLoading}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      ) : (
        <>
          <h2 className={styles.title}>Add social media</h2>
          <p className={styles.description}>
            Choose you social platform then enter your URL
          </p>

          <div className={styles.socialMediaList}>
            {socialMediaData.map((item) => (
              <div
                onClick={() => setSelectedSocial(item)}
                key={item.SocialMediaID}
                className={styles.socialMediaItem}>
                <img src={`https://${item.IconURL}`} alt={item.Title} />
                <p>{item.Title}</p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default AddSocialMediaModal;
